import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const REGISTRATION_COMPLETED = 'REGISTRATION_COMPLETED';

export const useOnRegistrationSuccess = (eventTarget: EventTarget): void => {
    const handleEvent = useCallback((detail: {
        playerCode: number;
        userId: string;
        username: string;
    }) => {
        const event = new CustomEvent(REGISTRATION_COMPLETED, { detail: [detail] });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('registration:success', handleEvent);

        return () => publicEventsAPIService.off('registration:success', handleEvent);
    }, [handleEvent]);
};
